<div class="barraListagem">
  <div class="barraFiltro">
    <div class="barraFiltroInterna">
      <div class="ui-g ui-fluid">

        <div class="ui-g-12">
          <label id="numeroAnuncio">Número do Anúncio</label>
          <tag-input id="numeroAnuncio" name="numeroAnuncio" [(ngModel)]='filtro.anuncioNumeros'
            [separatorKeyCodes]="separadores" [validators]="somenteNumero" placeholder="Número"
            secondaryPlaceholder="Filtrar por Número" addOnBlur="true" theme='bootstrap'></tag-input>
        </div>

        <div class="ui-g-12">
          <label for="pesquisa">Título do Anúncio</label>
          <input ngModel id="pesquisa" name="titulo" type="text" pInputText [(ngModel)]="filtro.anuncioTitulo"
            placeholder="Filtrar por Título ou Descrição" maxlength="200">
        </div>

        <div class="ui-g-12">
          <label for="anuncioSituacao">Situação</label>
          <p-multiSelect id="anuncioSituacao" name="anuncioSituacao" defaultLabel="Todos"
            [(ngModel)]="filtro.anuncioSituacoesSelecionadas" [options]="filtro.anuncioSituacoes" optionLabel="nome"
            dataKey="nome"></p-multiSelect>
        </div>

        <div class="ui-g-12">
          <div for="orgao"><strong>Órgão Donatário</strong></div>
          <p-dropdown #orgao id="orgao" [options]="listaOrgaos" [autoWidth]="false" (onChange)="recuperarEntidades()"
            [(ngModel)]="filtro.orgao" [filter]="true" optionLabel="idNome" dataKey="id"></p-dropdown>
        </div>
        <div class="ui-g-12">
          <div for="entidade"><strong>Donatário</strong></div>
          <p-dropdown #entidade id="entidade" [options]="listaDonatarios" [autoWidth]="false"
            [(ngModel)]="filtro.donatario" [filter]="true" optionLabel="nomeNumero" dataKey="id"
            [disabled]="listaDonatarios.length == 0"></p-dropdown>
        </div>

        <!--<div class="ui-g-12">
          <label for="donatario">Donatário</label>
          <p-multiSelect id="donatario" name="donatario" defaultLabel="Todos" [(ngModel)]="filtro.donatariosSelecionados"
            [options]="filtro.donatarios" optionLabel="nome" dataKey="nome"></p-multiSelect>
        </div>-->

        <div class="ui-g-12">
          <label for="periodoInclusao">Período de Publicação</label>
          <p-calendar id="periodoPublicacao" name="periodoPublicacao" [(ngModel)]="filtro.periodoPublicacao"
            selectionMode="range" readonlyInput="true" [locale]="pt" dateFormat="dd/mm/yy" [showIcon]="true"
            #periodoPublicacao>
            <p-footer>
              <div class="ui-datepicker-header ui-widget-header ui-helper-clearfix ui-corner-all footer-datepicker">
                <p-button icon="pi pi-check" class="button-datapicker-ok"
                  (onClick)="fecharCalendario(periodoPublicacao)"></p-button>
                <p-button icon="pi pi-times" class="button-datapicker-cancel"
                  (onClick)="limparPeriodoPublicacao(periodoPublicacao)"></p-button>
              </div>
            </p-footer>
          </p-calendar>
        </div>
      </div>
      <div class="ui-g-12 text-center">
        <p-button label="Limpar Filtros" styleClass="ui-button-secondary" icon="fa fa-trash" (click)="limparFiltros()">
        </p-button>
        <span class="espaco-r-5"></span>
        <p-button label="Aplicar" styleClass="ui-button-success" icon="fa fa-sliders" (click)="aplicarFiltros()">
        </p-button>
      </div>

    </div>
  </div>
  <div class="barraItens">
    <router-outlet></router-outlet>
  </div>
</div>
